import FloatingLabelHapi from 'tc/modules/subcomponents/floating-label/floating-label-hapi';
import FloatingLabelInput from 'tc/modules/subcomponents/floating-label/floating-label-input';
import FloatingLabelInputGroupBtn from 'tc/modules/subcomponents/floating-label/floating-label-input-group-btn';
import FloatingLabelSelect from 'tc/modules/subcomponents/floating-label/floating-label-select';

// Register all of our custom elements.
document.registerElement('floating-label-hapi', {prototype: FloatingLabelHapi});
document.registerElement('floating-label-input', {
    prototype: FloatingLabelInput,
});
document.registerElement('floating-label-select', {
    prototype: FloatingLabelSelect,
});

document.registerElement('floating-label-input-group-btn', {
    prototype: FloatingLabelInputGroupBtn,
    extends: 'button',
});
